// import { getUserInfo } from '@/utils/userinfo';
import Router from 'next/router';
import React, { useState } from 'react';

import ChartSearch from '@/src/compliance/components/CompliAssist';
import ChartDescriptionsModal from '@/src/compliance/components/CompliAssist/ChartDescriptions/Modal';
import CompliAssistDisclaimer from '@/src/compliance/components/CompliAssist/CompliAssistDisclaimer';
import SavedSearchesModal from '@/src/compliance/components/CompliAssist/SavedSearches';
import Button from '@/src/shared/components/Button';
import Container from '@/src/shared/components/Container';
import Hero from '@/src/shared/components/Hero';
import withMembershipAccessWrap from '@/src/shared/components/MembershipPageWrap';
import Section from '@/src/shared/components/Section';
import WebLogImage from '@/src/shared/components/WebLogImage';
import { checkAccess, COMPLIANCE_ACCESS } from '@/src/shared/constants';
import { useDispatch, useSelector } from 'react-redux';
import Error from '@/pages/_error';

const CompliAssist = props => {
  const [disclaimerModalVisible, showDisclaimerModal] = useState(false);
  const [isDescriptionsModalVisible, setDescriptionsVisible] = useState(false);
  const [isSavedSearchesModalVisible, setSavedSearchesModalVisible] = useState(false);

  async function handleDisclaimerModalClose() {
    showDisclaimerModal(false);
  }
  const { isLoggedIn, role } = useSelector(state => state.auth);
  const personId = useSelector(state => state.auth.userinfo.PersonID);
  const hasAccess = checkAccess(COMPLIANCE_ACCESS.COMPLIANCE, role);
  const isAuthorized = personId && Array.isArray(role) && hasAccess;
  const errorCode = isLoggedIn && !hasAccess ? 401.4 : 401;

  if (!isLoggedIn || !isAuthorized) return <Error status={errorCode} />;


  return (
    <>
      <Hero title="Compliance Charts">
        <p>
          Click on the “My Saved Searches” button if you’d like to revisit these search criteria at
          a later date. This search will be stored under the “My Saved Searches” tab and also in the
          “My APCIA” section of the home page.
        </p>
        <Button onClick={() => setSavedSearchesModalVisible(true)} type="button">
          MY SAVED SEARCHES
        </Button>
        <div>
          <Button theme="link" onClick={() => setDescriptionsVisible(true)}>
            Chart Descriptions
          </Button>
          <Button theme="link" onClick={() => showDisclaimerModal(true)}>
            Disclaimer
          </Button>
          <Button
            theme="link"
            onClick={() =>
              Router.push(
                '/compliance/compliassist/recent-changes',
                '/compliance/compliassist/recent-changes'
              )
            }
          >
            Recent Changes
          </Button>
          <Button
            theme="link"
            onClick={() =>
              Router.push(
                '/account/subscription-preferences/',
                '/account/subscription-preferences/#compliassist'
              )
            }
          >
            Subscribe to Changes
          </Button>
        </div>
      </Hero>
      <Section bgColor="gray">
        <Container>
          <ChartSearch searchFilterKey={1} />
          <CompliAssistDisclaimer
            visible={disclaimerModalVisible}
            handleModalClose={handleDisclaimerModalClose}
          />
          <ChartDescriptionsModal
            visible={isDescriptionsModalVisible}
            closeModal={() => setDescriptionsVisible(false)}
          />
          <SavedSearchesModal
            visible={isSavedSearchesModalVisible}
            closeModal={() => setSavedSearchesModalVisible(false)}
          />
        </Container>
      </Section>
      <WebLogImage browserPath title="Compliance Charts" />
    </>
  );
};

export default withMembershipAccessWrap(CompliAssist);
